/**
 * CSR시 쿠키를 읽어오는 함수
 */
function getCookies() {
    if (typeof document === 'undefined') {
        return new Map([['', '']]);
    }
    return new Map(document.cookie.split('; ').map((item) => {
        const parts = item.split('=');
        return [parts[0], parts.slice(1).join('=')];
    }));
}
function getValue(type) {
    const value = getCookies().get(type);
    return value === 'unknown' || value === undefined ? null : value;
}
function getPlatform() {
    return getValue('platform');
}
function getVendor() {
    return getValue('vendor');
}
function isPosPlatform() {
    return getPlatform() === 'pos';
}
function isAndroidTerminalPlatform() {
    return getPlatform() === 'android-terminal';
}
function isFromConnectService() {
    return isPosPlatform() || isAndroidTerminalPlatform();
}
const cookieService = {
    getPlatform,
    getVendor,
    isPosPlatform,
    isAndroidTerminalPlatform,
    isFromConnectService,
};

export { cookieService };
//# sourceMappingURL=cookieService.js.map
